import React, {Component} from 'react';

class RenderDocumentHeader extends Component {
    render() {
        return (
            <div>
               header
            </div>
        );
    }
}

export default RenderDocumentHeader;